import useDesktopChecker from "hooks/useDesktopChecker";
import "./guide-loan-officer-card.scss";
import { LoanOfficerDetail } from "pages/application/applicationService";
import { LOAN_OFFICER_CARD_UNFORMATTED_PHONE_NUMBER } from "utilities/Constant";
import { GLOBAL_LINK_NO_TX_CLASS } from "utilities/globalLinkNoTx";

interface GuideLoanOfficerCardProps {
  readonly loInfo?: LoanOfficerDetail;
  readonly onClose?: () => void;
  readonly firstName?: string;
  readonly onCallNowClick?: () => void;
  readonly fsElementName?: string;
}

export default function GuideLoanOfficerCard({
  loInfo,
  onClose,
  firstName,
  onCallNowClick,
  fsElementName,
}: GuideLoanOfficerCardProps) {
  const isDesktop = useDesktopChecker();
  const phoneNumber = loInfo?.phones?.[0]?.number || loInfo?.phoneNumber || LOAN_OFFICER_CARD_UNFORMATTED_PHONE_NUMBER;

  return (
    <div className="guide-lo-card__container" data-fs-element={fsElementName}>
      <button type="button" className="guide-lo-card__close" onClick={onClose} aria-label="Close">
        &#10005;
      </button>
      <div className="guide-lo-card__wrapper">
        <div className="guide-lo-card__content paragraph-medium-semibold">
          Hi <span className={GLOBAL_LINK_NO_TX_CLASS} data-testid="guide-lo-first-name">{firstName}</span>
        </div>
        <div className="guide-lo-card__description paragraph-medium-regular">
           Want to talk about your loan options?
        </div>
        {!isDesktop && (
          <a
            className="guide-lo-card__call-link label-large-medium"
            href={`tel:${phoneNumber}`}
            onClick={onCallNowClick}
          >
            Call Us Now
          </a>
        )}
      </div>
    </div>
  );
}
